import type { TariffType } from '@/entities/Quote';
import type { DefaultResponse } from '@/shared/api';

export interface Policy {
  user: {
    name: string;
    email: string;
  };
  policy: {
    policyId: string;
    link: string;
    receiptLink: string;
    combinedReceiptLink: string;
  };
  showPromo: boolean;
  earnedBonuses: number;
  isUserRegistered: boolean;
  cyberSecurityWordingsLink: string;
  withCyberSecurity: boolean;
}

export interface CorePolicy {
  policy: {
    link: string;
  };
}

export enum PolicyStatus {
  RENEWABLE = 'expired_renewable',
  NON_RENEWABLE = 'expired_nonrenewable',
  UPCOMING = 'upcoming',
  ACTIVE = 'active_renewable',
  ACTIVE_NON_RENEWABLE = 'active_nonrenewable',
}

export interface ActivePolicyState {
  user: {
    transId: string | null;
  };
  policy: {
    policyId: string;
    startDate: Date;
    endDate: Date;
    status: PolicyStatus;
    tariffType: TariffType;
  };
  car: {
    makeName: string | null;
    modelName: string | null;
    makeId: string | null;
    modelYear: number | null;
  };
  isInstallment: boolean;
  isDowngraded: boolean;
  isTPLAvailable: boolean;
  isComprehensiveAvailable: boolean;
}

export interface PolicyState {
  policyId: string;
  newPolicyInfo: Policy | null;
  startDate: Date | null;
  endDate: Date | null;
  status: PolicyStatus | null;
  transId: string;
  activePolicyState: ActivePolicyState | null;
  noInstallmentForPolicy: boolean;

  isContinueBuying: boolean; // FlowStore?
  upgradeInstalmentPayment: boolean; // FlowStore?
  isInstallment: boolean; // FlowStore?
  isDowngraded: boolean; // FlowStore?
}

export interface CheckPolicyByVINRequest {
  vin: string;
  plateNumber?: string;
  userId?: string;
  tariffType: TariffType | null;
}

// TODO: refactor installment interfaces below

export interface GetPolicyStateByVin {
  chassisNumber: string;
  plateNumber?: number;
  tariff: number;
}

export interface GetPolicyStateByPolicyNumber {
  policyNumber: number;
  transId: string;
}

export interface GetPolicyStateByGuid {
  guid: string;
}

export type GetPolicyStateParams
  = | GetPolicyStateByVin
    | GetPolicyStateByPolicyNumber
    | GetPolicyStateByGuid;

export interface GetPolicyStateResponse extends DefaultResponse {
  policyNumber: string;
  policyStartDate: Date;
  policyEndDate: Date;
  state: PolicyStatus;

  transId: string;
  makeId: string;
  makeName: string;
  // ? что с этим ? (обратная совместимость с инстоллментами)
  makeModel: string;
  modelName: string;
  brandCode: string;
  modelYear: string;
  isInstallment: boolean;
  isDowngraded: boolean;
  isTPLAvailable: boolean;
  isComprehensiveAvailable: boolean;
}
